import styled from 'styled-components';
import { Row } from 'react-bootstrap';

export const CustomRow = styled(Row)`
    @media (max-width: ${({ theme }) => theme.devices.desktop}) {
        flex-direction: column;
    }
`;
